exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.items[data-v-110a1a12] {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 200px);\n  grid-gap: 16px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 16px;\n}\n", ""]);

// exports
